module.exports = __webpack_public_path__ + "media/images/chevron-left-icon-e9d040c0.svg";